import { render, staticRenderFns } from "./ScoutTabUnderReview.vue?vue&type=template&id=501cca82"
import script from "./ScoutTabUnderReview.vue?vue&type=script&lang=js"
export * from "./ScoutTabUnderReview.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports